export default __webpack_public_path__ + "static/mini-program-code-06224ddc55bc45cc6860d87fb4e2e281.png";